<template>
  <a-layout style="height: 100%;" class="animate__animated animate__zoomIn">
    <a-layout-sider style="background-color:#fff;" v-model="isCollapse">
      <SiderMenu :isCollapse="isCollapse" :menus="menus" />
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background-color:#fff;border-bottom: 1px solid #e8e8e8;">
        <div class="header-inner">
          <a-icon :type="isCollapse ? 'menu-unfold' : 'menu-fold'" class="fold-icon" @click="toggleCollapse" />
          <div class="icons">
            <span v-show="isDark" class="iconfont icon-sun" @click="toDayModel"></span>
            <span v-show="!isDark" class="iconfont icon-moon" @click="toNightModel"></span>
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <svg t="1717551059438" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4459" width="30" height="40"><path d="M757.205333 473.173333c5.333333 0 10.453333 2.090667 14.250667 5.717334a19.029333 19.029333 0 0 1 5.888 13.738666v58.154667h141.184c11.093333 0 20.138667 8.704 20.138667 19.413333v232.704a19.797333 19.797333 0 0 1-20.138667 19.413334h-141.184v96.981333a19.754667 19.754667 0 0 1-20.138667 19.370667H716.8a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.888-13.696v-96.981333h-141.141333a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.930666-13.738667v-232.704c0-5.12 2.133333-10.112 5.930666-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h141.141333v-58.154667c0-5.162667 2.133333-10.112 5.888-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h40.362667zM192.597333 628.394667c22.272 0 40.32 17.365333 40.32 38.826666v38.741334c0 40.618667 32.512 74.368 74.624 77.397333l6.058667 0.213333h80.64c21.930667 0.469333 39.424 17.706667 39.424 38.784 0 21.077333-17.493333 38.314667-39.424 38.784H313.6c-89.088 0-161.28-69.461333-161.28-155.178666v-38.741334c0-21.461333 18.005333-38.826667 40.277333-38.826666z m504.106667 0h-80.64v116.394666h80.64v-116.394666z m161.28 0h-80.64v116.394666h80.64v-116.394666zM320.170667 85.333333c8.234667 0 15.658667 4.778667 18.773333 12.202667H338.773333l161.322667 387.84c2.517333 5.973333 1.706667 12.8-2.005333 18.090667a20.394667 20.394667 0 0 1-16.725334 8.533333h-43.52a20.181333 20.181333 0 0 1-18.688-12.202667L375.850667 395.648H210.901333l-43.264 104.149333A20.181333 20.181333 0 0 1 148.906667 512H105.514667a20.394667 20.394667 0 0 1-16.725334-8.533333 18.773333 18.773333 0 0 1-2.005333-18.090667l161.28-387.84A20.181333 20.181333 0 0 1 266.88 85.333333h53.290667zM716.8 162.901333c42.794667 0 83.84 16.341333 114.090667 45.44a152.234667 152.234667 0 0 1 47.232 109.738667v38.741333c-0.469333 21.077333-18.389333 37.930667-40.32 37.930667s-39.808-16.853333-40.32-37.930667v-38.741333c0-20.608-8.490667-40.32-23.637334-54.869333a82.304 82.304 0 0 0-57.045333-22.741334h-80.64c-21.888-0.469333-39.424-17.706667-39.424-38.784 0-21.077333 17.493333-38.314667 39.424-38.784h80.64z m-423.424 34.304L243.2 318.037333h100.48L293.418667 197.205333z" fill="#666" p-id="4460"></path></svg>
              </a>
              <a-menu slot="overlay">
                <a-menu-item :disabled="lang === 'zh'" key="zh" @click="changeLang('zh')">
                  <a :class="{ disabled: lang === 'zh' }">中文</a>
                </a-menu-item>
                <a-menu-item :disabled="lang === 'en'" key="en" @click="changeLang('en')">
                  <a :class="{ disabled: lang === 'en' }">Engilsh</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <TagsView :menus="menus" />
          <HeaderRight />
        </div>
      </a-layout-header>
      <a-layout-content style="background-color: #fff;height: 100%;">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import SiderMenu from '../components/common/SiderMenu'
import HeaderRight from '../components/common/HeaderRight'
import { enable, disable, setFetchMethod } from 'darkreader'
import TagsView from './TagsView.vue'
import { getMenusOfCurrentUser } from '@/api/auth/menu'

export default {
  name: 'BasicLayout',
  components: { HeaderRight, SiderMenu, TagsView },
  data() {
    return {
      isCollapse: false,
      isDark: false,
      menus: [],
      lang: 'zh'
    }
  },
  async created() {
    setFetchMethod(window.fetch)
    const data = JSON.parse(localStorage.getItem('menus')) || []
    const index = data.findIndex(m => m.routeName === 'Overview')
    const route = data.splice(index, 1)
    data.unshift(route[0])
    this.menus = data.filter(d => d.isMobile !== 1)
    const lang = localStorage.getItem('lang') || 'zh'
    this.changeLang(lang)
    const theme = localStorage.getItem('theme') || 'light'
    if (theme === 'light') {
      this.toDayModel()
    }
    if (theme === 'dark') [
      this.toNightModel()
    ]
  },
  methods: {
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    toDayModel() {
      disable()
      this.isDark = false
      localStorage.setItem('theme', 'light')
    },
    toNightModel() {
      enable({
        brightness: 100,
        contrast: 100,
        sepia: 10
      })
      this.isDark = true
      localStorage.setItem('theme', 'dark')
    },
    changeLang(locale) {
      this.lang = locale
      localStorage.setItem('lang', locale)
      this.$store.commit('setLang', locale)
      this.$i18n.locale = locale
      document.title = this.$t('documentTitle')
    }
  }
}
</script>

<style lang="less" scoped>
  // .ant-layout-header {
  //   filter: invert(1) hue-rotate(180deg);
  // }
  .header-inner {
    display: flex;
    align-items: center;
    position: relative;
    .fold-icon {
      font-size: 30px;
      margin-left: -20px;
      margin-top: -10px;
      cursor: pointer;
    }
    .icons {
      position: absolute;
      top: 0;
      right: 220px;
      z-index: 1;
      width: 80px;
      display: flex;
      justify-content: space-between;
      span {
        font-size: 26px;
        cursor: pointer;
      }
      .ant-dropdown-link {
        display: flex;
        align-items: center;
      }
      .icon {
        // position: absolute;
        // top: 10px;
        // left: 45px;
        fill: #666;
      }
    }
  }
  .disabled {
    color: #ddd;
    cursor: not-allowed;
  }
</style>
